// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.full-width-table th, .full-width-table td {
  border: 1px solid #ccc;
  padding: 10px;
  text-align: left;
}

.full-width-table th {
  background-color: #f0f0f0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/HistoryPatient.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".full-width-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 10px;\n}\n\n.full-width-table th, .full-width-table td {\n  border: 1px solid #ccc;\n  padding: 10px;\n  text-align: left;\n}\n\n.full-width-table th {\n  background-color: #f0f0f0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
